import "#finder-legacy/physician_finder/helpers/utils.js";
import "#/legacy/namespaces.js";
import "./base.js";

DoctorFinder.Views.WizardStep = class WizardStep extends DoctorFinder.Views.Base {
  constructor() {
    super(...arguments);
    this.isFilterEnabled = this.isFilterEnabled.bind(this);
    this.requiredFiltersLocked = this.requiredFiltersLocked.bind(this);
    this.visible = this.visible.bind(this);
    this.locationDescription = this.locationDescription.bind(this);
  }

  isFilterEnabled(filterName) {
    return this.options.showFilters && DoctorFinder.Helpers.isFilterEnabled(this.options.filters, filterName);
  }

  // When the legally required filters modal is enabled the location and insurance
  // filters must always remain set, so they can never be cleared (see
  // <sp-required-filters-modal>).
  requiredFiltersLocked() {
    return !!this.options.locationSettings?.filterOptions?.required_filters_modal;
  }

  visible(visible) {
    return this.locationSearch?.wizardStepVisible(visible);
  }

  locationDescription(distance, location) {
    if (distance == null) {
      ({ distance } = this.collection.filters);
    }
    if (location == null) {
      location = this.collection.filters.zip;
    }
    if (distance && location && distance !== DoctorFinder.Views.LocationSearch.ANY_DISTANCE) {
      return `Within ${distance} miles of ${location}`;
    } else if (location) {
      return location;
    } else {
      return this.locationPlaceHolder || "";
    }
  }
};
